<div class="flex items-center gap-1">
  <div class="text-sm">x</div>

  <div class="text-sm line-through">
    <app-number
      [value]="originalQuantity()"
      unit="szt." />
  </div>

  <div class="flex items-center gap-1">
    <div>
      <app-number
        [value]="currentQuantity()"
        unit="szt." />
    </div>
  </div>
</div>
